/** If a field value within a filter has this structure, it indicates it is to
 * be rendered as a placeholder instead. Not every field can be a placeholder */
export type TemplatePlaceholder = {
  placeholder: {
    title: string;
    description?: string;
    optional?: boolean;
    position?: number;
  };
};

/**
 * Type guard for TemplatePlaceholder
 *
 * @param value - the value to check
 *
 * @returns true if the value is a TemplatePlaceholder, false otherwise
 */
export function isTemplatePlaceholder(value: unknown): value is TemplatePlaceholder {
  // TODO: Can this be tightened up a bit?
  return (
    typeof value === 'object' &&
    value !== null &&
    'placeholder' in value &&
    typeof value.placeholder === 'object' &&
    value.placeholder !== null &&
    'title' in value.placeholder
  );
}
